import {
  Mail,
  Heart,
  Smartphone,
  TrendingUp,
  Briefcase,
  BarChart3,
  DollarSign,
  ShoppingCart,
  Zap,
  Globe2,
  ShieldCheck,
  Users2,
  CheckCircle2,
  Sliders,
} from "lucide-react";

export const EMAIL_HERO_STATS = [
  {
    percentage: "99%",
    desc: "of client's check their email every day.",
    icon: Mail,
  },
  {
    percentage: "80%",
    desc: "of employers believe that email marketing increases customer loyalty.",
    icon: Heart,
  },
  {
    percentage: "73%",
    desc: "of millennials prefer corporate communication through email.",
    icon: Smartphone,
  },
  {
    percentage: "59%",
    desc: "of marketers say that email is their biggest source of ROI.",
    icon: TrendingUp,
  },
  {
    percentage: "86%",
    desc: "of top business professionals use email to communicate for business purposes.",
    icon: Briefcase,
  },
  {
    percentage: "73%",
    desc: "of marketers rate email as the most important digital channel for ROI.",
    icon: BarChart3,
  },
  {
    percentage: "59%",
    desc: "of B2B marketers consider email marketing the most effective channel for generating income.",
    icon: DollarSign,
  },
  {
    percentage: "50%",
    desc: "buy at least once a month through marketing emails.",
    icon: ShoppingCart,
  },
];

export const EMAIL_BENEFITS = [
  { title: "Low-Cost Marketing", icon: DollarSign, desc: "Maximized ROI with minimal campaign overhead." },
  { title: "Assured Audience Engagement", icon: Users2, desc: "Direct 1-to-1 inboxes that demand buyer attention." },
  { title: "Easy to Get Started", icon: Zap, desc: "Rapid deployment and immediate segmentation setups." },
  { title: "Measurable Results", icon: BarChart3, desc: "Precise open, click-through, and conversion telemetry." },
  { title: "Global Audience Reach", icon: Globe2, desc: "Connect with target markets across 170+ countries." },
  { title: "Instant Impact", icon: TrendingUp, desc: "Drive immediate traffic and trigger instant replies." },
  { title: "Build Credibility", icon: ShieldCheck, desc: "Foster authentic trust through custom domain delivery." },
  { title: "Maintain Customer Relationships", icon: Heart, desc: "Consistent nurturing loops for lifelong retention." },
];

export const MULTICHANNEL_PILLARS = [
  {
    title: "Print & Digital Integration",
    desc: "Synchronized print marketing touchpoints aligned with email cadences for brand consistency.",
    icon: Sliders,
  },
  {
    title: "Adaptive Buyer Journey",
    desc: "Meeting prospects on their preferred channels to maximize aggregate engagement and closed pipeline.",
    icon: CheckCircle2,
  },
];